/* NAXHORE Theme — base.js */
(function(){
  'use strict';

  /* Mobile menu */
  var menuBtn = document.getElementById('menuBtn');
  var navLinks = document.getElementById('navLinks');
  if(menuBtn && navLinks){
    menuBtn.addEventListener('click', function(){
      navLinks.classList.toggle('open');
    });
  }

  /* Cart count */
  var countEl = document.querySelector('[data-cart-count]');
  if(countEl){
    try{
      var items = JSON.parse(localStorage.getItem('cart') || '[]');
      countEl.textContent = items.length ? items.length : '';
    }catch(e){}
  }

  /* Toast helper */
  function toast(msg){
    var t = document.getElementById('toast');
    if(!t) return;
    t.textContent = msg;
    t.classList.add('show');
    setTimeout(function(){ t.classList.remove('show'); }, 2600);
  }

  /* Product form — capture cart count on add */
  var form = document.querySelector('.product-form');
  if(form){
    form.addEventListener('submit', function(){
      var count = parseInt(localStorage.getItem('naxhoreCount') || '0', 10);
      count += 1;
      localStorage.setItem('naxhoreCount', count);
    });
  }

  /* Sync quantity + add-to-cart UX for cart page (guest cart not available pre-checkout) */
  var checkoutBtn = document.querySelector('[name="checkout"]');
  if(checkoutBtn){
    checkoutBtn.addEventListener('click', function(){
      toast('Redirecting to checkout…');
    });
  }

  /* Product gallery thumbs */
  var thumbs = document.querySelectorAll('.thumbs img');
  var mainImg = document.querySelector('.product-gallery > img');
  if(thumbs.length && mainImg){
    thumbs.forEach(function(th){
      th.addEventListener('click', function(){
        mainImg.src = th.src.replace('_200x','_900x');
      });
    });
  }
})();
